<template>
	<div style="padding-top:30%">
		<div align="center">
			<img src="../../static/images/order/sc.png" class="custom-image" />
		</div>
		<div style="text-align: center">
			<p class="title">{{title}}</p>
			<p class="content">{{content}}</p>
			<van-button round type="danger" class="bottom-button" @click="buttonClick" v-show="!notbutton">
				{{button}}
			</van-button>
		</div>
	</div>
</template>

<script>
	import wx from 'weixin-js-sdk';
	export default {
		props: {
			list: {
				type: Array,
				default: null,
			},
			title: {
				type: String,
				default: '空空如也',
			},
			content: {
				type: String,
				default: '每天都给自己一个惊喜，去首页逛逛',
			},
			button: {
				type: String,
				default: '去逛逛',
			},
			img: {
				type: String,
				default: require('../../static/images/order/sc.png'),
			},
			back: { //是否返回首页
				type: Boolean,
				default: true,
			},
			notbutton: { //是否显示按钮
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {

			};
		},
		methods: {
			buttonClick() {
				if (this.back) {
					console.log(111)
					setTimeout(() => {
                    this.$router.push({
                        path: "/index2",
                    });
                }, 1000);
				} else {
					this.$emit("click");
					console.log(222)
				}

			},
		},
		mounted() {

		}
	};
</script>

<style lang="scss" scoped>
	.custom-image {
		width: 180px;
		height: 180px;
	}

	.title {
		font-size: 28px;
		color: #333333;
		font-weight: 600;
		margin-bottom: 10px;
	}

	.content {
		font-size: 26px;
		color: #999999;
		margin-bottom: 40px;
	}

	.bottom-button {
		width: 250px;
		height: 70px;
		background: $theme-color-main;
		border: 1px solid $theme-color-main;
	}
</style>
